import { defaultLocale, getLocalizedHomepageContent, isSupportedLocale } from '../data/homepageContent'

export function getHomepageContent(locale = defaultLocale) {
  return getLocalizedHomepageContent(locale)
}

export async function fetchHomepageContent(locale = defaultLocale) {
  // Backend-ready adapter: replace this with fetch(`/api/homepage?lang=${locale}`) once an API exists.
  return Promise.resolve(getHomepageContent(locale))
}

export function normalizeHomepageLocale(locale) {
  return isSupportedLocale(locale) ? locale : defaultLocale
}
